import { Injectable } from '@angular/core';
import { CanActivate, RouterStateSnapshot, ActivatedRouteSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from './auth.service';
import { GtagService } from '@easy-lib/modules/shared/services/gtag.service';

@Injectable({
	providedIn: 'root'
})
export class AuthGuard implements CanActivate {
	constructor(
		private authService: AuthService,
		private gtagService: GtagService
	) {}

	canActivate(
		next: ActivatedRouteSnapshot,
		state: RouterStateSnapshot
	): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
		return this.authService.getUser.then(() => {
			if (this.authService.isLoggedIn()) {
				return true;
			}
			this.gtagService.sendGtagEvent('redirect-to-account');
			localStorage.setItem('redirect-after-login', state.url);
			this.authService.startAuthentication();

			return false;
		});
	}
}
